

export default function AlertBox({
  type = "warning", // warning | info | success | error
  title,
  children,
  icon,
}) {

  const iconMap = {
    warning: "fas fa-exclamation-triangle",
    info: "fas fa-info-circle",
    success: "fas fa-check-circle",
    error: "fas fa-times-circle",
  };

  return (
    <div className='push-tip'>
      <i className={icon || iconMap[type]} />
      <div>
        {title && <strong>{title}</strong>}
        <div className="alert-content">
          {children}
        </div>
      </div>
    </div>
  );
}
